import { PhoneNumberWithPrefixSchema } from "@modules/box/boxTypes"
import { ExperienceLevel, Goals, HeardAboutUs, LeadType } from "@modules/boxLead/entities/boxLeadTypes"
import { z } from "zod"

export const BoxLeadInputDtoSchema = z
  .object({
    userId: z.string().nullish(),
    experienceLevel: z.nativeEnum(ExperienceLevel).nullish(),
    goals: z.array(z.nativeEnum(Goals)).nullish(),
    hearAboutUs: z.nativeEnum(HeardAboutUs).nullish(),
    hearAboutUsSpecify: z.string().max(255).nullish(),
    bestTimeToContact: z.string().max(255).nullish(),
    madeByStaffId: z.string().nullish(),
    firstname: z.string().max(64).nullish(),
    lastname: z.string().max(64).nullish(),
    email: z.string().email().max(320).nullish(),
    phoneNumber: PhoneNumberWithPrefixSchema.nullish(),
    note: z.string().max(255).nullish(),
    firstContact: z.string().datetime(),
    leadType: z.nativeEnum(LeadType),
  })
  .refine((data) => {
    if (!data.userId && (!data.firstname || !data.lastname)) {
      return false
    }
    return true
  })

export type BoxLeadInputDto = z.infer<typeof BoxLeadInputDtoSchema>
